import { ca } from '@cian/analytics';
import { adAnalyticsCategory } from '../../scripts/services/analytics.service';

export const trackRetryPaymentClick = label => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'retry_to_pay',
    label,
  });
};
